import { useShallow } from "zustand/react/shallow"
import { useParams } from "react-router-dom"
import { FORM_VIEW_STATE } from "constants/authoring.js"
import useAuthoringViewStore from "../stores/useAuthoringViewStore"
import useAuthoringStore from "../stores/useAuthoringStore"
import useAuthoringTranslations from "../stores/useAuthoringTranslations"
import { useReactToPrint } from "react-to-print"

const printFormSectionSet = new Set(["secondaryAttributes", "sponsorTrialWebsite"])

const useAuthoringPrintActions = () => {
  const { studyId } = useParams()
  const authoringId = useAuthoringStore((state) => state.authoringId)

  const { formView, formSection, showVersionCompare } = useAuthoringViewStore(
    useShallow((state) => ({
      setShowPagePreview: state.setShowPagePreview,
      formView: state.formView,
      formSection: state.formSection,
      showVersionCompare: state.showVersionCompare,
    }))
  )

  const { isTranslationActive, selectedLanguage, translationLanguages } = useAuthoringTranslations()

  const onPrintPage = async (options) => {
    if (showVersionCompare || printFormSectionSet.has(formSection?.id)) {
      await new Promise((r) => setTimeout(r, 1000))
      handlePrint()
    } else {
      let jsonData = {
        formSection,
        formView,
        isTranslationActive,
        selectedLanguage,
        translationLanguages,
        showVersionCompare,
      }

      if (options) {
        jsonData = {
          ...jsonData,
          ...options,
        }
      }

      localStorage.setItem(FORM_VIEW_STATE, JSON.stringify(jsonData))
      window.open(`/study/${studyId}/study-data/${authoringId}/print-page`, "_blank", "rel=noopener noreferrer")
    }
  }

  const handlePrint = useReactToPrint({
    content: () => document.getElementsByClassName("authoring-content-container")?.[0],
    removeAfterPrint: true,
  })

  return {
    onPrintPage,
  }
}

export default useAuthoringPrintActions
